import { errorMessageFrom } from "../utils/formErrors";
import { useOrgEmployees } from "../services/useOrgData";
import React,{useState} from 'react';
import {Box, CircularProgress} from '@mui/material';
import BtnPrimary from './PrimaryButton';
import FormField from './Formfield';
import MainBox from "../app/main/container/MainBox";
import { createGroup } from "../services/employeeGroups";
import { getActiveLegalUnit } from "../services/globalData";
import CheckboxField from './CheckboxField';
import SuccessDialog from './SuccessDialog';


import { useNotify } from './NotificationProvider';

import { tokens } from "../theme";
const CreateGroup = ({redirectLink, loadNextPage}) => {
    const notify = useNotify();
    const [apiCall,setApiCall]=useState(false);
    const [name,setName] = useState("");
    const [selectionType,setSelectionType]=useState("Employee name");
    const { data: employeeList } = useOrgEmployees();
    const [employee,setEmployee]=useState([]);
    const [isDialogOpen,setIsDialogOpen]=useState(false);

    const handleNextClick = async() =>{
        const legalUnit = getActiveLegalUnit();
        const groupData = {name:name,employee:employee, legalUnit:legalUnit?._id}
        setApiCall(true);
        try {
            const res = await createGroup(groupData);
            if(res.success){
                setIsDialogOpen(true);
                setName("");
                setEmployee([]);
            } else {
                notify.error(errorMessageFrom(res, "Could not create group"));
            }
        } catch (error) {
            notify.error(error?.message || "Something went wrong creating the group");
        } finally {
            setApiCall(false);
        }
    }

    const handleCheckboxChange = (id, isChecked) => {
        if (isChecked) {
            setEmployee(prevEmployee => [...prevEmployee, id]);
        } else {
            setEmployee(prevEmployee => prevEmployee.filter(empId => empId !== id));
        }
    };

    return (
      <Box>
          <Box sx={{ width: "100%", display: "flex", flexDirection: "row", flexWrap: "wrap", justifyContent: "space-between" }}>
                        <FormField
                            label="Group Name"
                            type="text"
                            value={name}
                            onChange={(e)=>setName(e.target.value)}
                        />
           </Box>
           <Box sx={{
                     fontSize: '1rem',
                     lineHeight: '1.5rem',
                     color: tokens.textMuted,
                     marginBottom: '4px'
                    }}>
                No. of employees selected : {employee.length}
            </Box>
           <MainBox sx={{padding: "2rem"}}>
                      <FormField
                          type="select"
                          options={["Employee name","Department name","Group name", "Designation"]}
                          value={selectionType}
                          onChange={(e)=>{setSelectionType(e.target.value)}}
                      />
                      <Box sx={{display:"flex", gap: "1.25rem", flexWrap:"wrap"}}>
                          {employeeList.map((item)=>(
                            <Box sx={{backgroundColor: '#F5E9E1',  borderRadius:"6px",padding: "4px", width:"10rem", height:"2rem",
                                textAlign:"center", fontWeight:"600", fontSize: '0.875rem', 
                                lineHeight: '1.125rem', color:"#2A1D2280", letterSpacing:"-2.5%",
                                display:"flex", alignItems:"center"
                              }}>
                                <CheckboxField
                                    checked={employee?.includes(item._id)}
                                    onChange={(isChecked) => handleCheckboxChange(item._id, isChecked)}
                                />
                                {item.fname+" "+item.lname}
                            </Box>
                          ))}
                      </Box>
           </MainBox>
           <Box sx={{display:"flex", justifyContent:"end", gap: "1rem", marginTop: "2rem"}}>
                    <BtnPrimary 
                      onClick={handleNextClick} 
                      sx={{width:"11.875rem", height:"3.125rem", borderRadius:"10px"}}
                      disabled={apiCall}
                    >
                        {apiCall?<CircularProgress/>:"Save Group"}
                    </BtnPrimary>
            </Box>
            <SuccessDialog 
              open={isDialogOpen} 
              onClose={()=>setIsDialogOpen(false)} 
              message={`${name} group is created successfully!`} 
              addNewLink={redirectLink} 
              addNewText="Create New Group" 
              viewAllLink={() => loadNextPage("sortBy")} 
              viewAllText="Continue Assigning Policy"
            />
      </Box>
    )
}

export default CreateGroup